import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'
import { Fetch } from '../../shared/Fetch'
import { emptyFormData, IFormData } from './Form'
import { IModal } from './Projects'
import { useNavigate } from 'react-router-dom';

interface Iprops {
    toast: any,
    setModal: (modal: IModal) => void,
    reload: boolean,
    hasPermission: (pageName: string, featureName?: string) => Boolean,
};

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState<IFormData[]>([]);

    const navigate = useNavigate();

    const ProjectNameColumn = (rowData: any) => {
        return (
            <span
                style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => navigate(`/testcases`, { state: { projectId: rowData.id } })}
            >
                {rowData.project_Name}
            </span>
        );
    };

    const Action = (rowData: IFormData) => {
        return (
            <>
                <Button
                    icon="pi pi-pen-to-square"
                    className="p-button-rounded p-button-secondary p-button-text"
                    onClick={() => openEditModel(rowData)}
                />
            </>
        );
    };
    const openEditModel = (rowData: IFormData) => {
        console.log(rowData);
        props.setModal({ open: true, singleData: rowData });

    }

    const leftToolbarTemplate = () => {
        return (
            <>
                <p className="mt-2 font-bold text-xl">Projects List</p>
            </>
        )
    }
    const rightToolbarTemplate = () => {
        return (
            <div className="my-2">
                <Button label="Add Projects" icon="pi pi-plus" className="p-button mr-2 mt-1" onClick={postProject} />
            </div>
        )
    }
    const postProject = () => {
        props.setModal({ open: true, singleData: emptyFormData });
    }

    const LoadTableData = async () => {
        const response = await Fetch("Projects", "GET", null, null, props.toast)
        if (response) {
            const data = await response.json();
            setTableData(data)
        }
        else {
            props.toast.current.show({ severity: 'error', detail: "Failed to Load data", life: 3000 });
        }
    };

    useEffect(() => {
        LoadTableData();
    }, [props.reload]);

    const toggleVal = async (id?: number) => {
        const response = await Fetch("Projects/togglestatus", "PUT", null, `project_ID=${id}`, props.toast);
        if (response) {
            let message: string = " Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            LoadTableData();

        }
    };

    const ReferenceStatus = (rowData: IFormData) => {
        return (
            <span style={{ color: rowData.status == true ? 'blue' : 'red' }} className="cursor-pointer" onClick={() => { toggleVal(rowData.id) }}>{rowData.status ? "Active" : "InActive"}</span>
        );
    };

    return (
        <>
            <Toolbar
                className="mb-1 py-0"
                left={leftToolbarTemplate}
                right={rightToolbarTemplate}
            ></Toolbar>
            <DataTable
                style={{ fontSize: "15px" }}
                value={tableData}
                lazy
                dataKey="id"
                size="small"
                tableStyle={{ minWidth: "50rem", maxHeight: "3rem" }}
                showGridlines
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="project_Name" header="Project Name" body={ProjectNameColumn} />
                <Column field="status" header="Status" body={ReferenceStatus} />
                <Column body={Action} header="Action" />
            </DataTable>
        </>
    )
}